import React from "react";
import Nav from "@/components/Nav";
import SEO from "@/components/SEO";
import JsonLd, { orgSchema } from "@/components/JsonLd";
import Hero from "@/components/Hero";
import GlobalTrustStrip from "@/components/GlobalTrustStrip";
import ServicesFour from "@/components/ServicesFour";
import ErpLeadership from "@/components/ErpLeadership";
import TrustLogos from "@/components/TrustLogos";
import Products from "@/components/Products";
import WhyMaxine from "@/components/WhyMaxine";
import WebPackages from "@/components/WebPackages";
import Process from "@/components/Process";
import Cloud from "@/components/Cloud";
import Marketing from "@/components/Marketing";
import SuccessStories from "@/components/SuccessStories";
import CaseStudies from "@/components/CaseStudies";
import WorldMap from "@/components/WorldMap";
import Insights from "@/components/Insights";
import Careers from "@/components/Careers";
import GlobalReach from "@/components/GlobalReach";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsappFAB from "@/components/WhatsappFAB";
import MobileStickyCTA from "@/components/MobileStickyCTA";
import TawkChat from "@/components/TawkChat";
import useHashScroll from "@/hooks/useHashScroll";

export default function Home() {
  useHashScroll();
  return (
    <div data-testid="public-home" className="min-h-screen bg-white text-[color:var(--ink)]">
      <SEO />
      <JsonLd data={orgSchema(typeof window !== "undefined" ? window.location.origin : "")} />
      <Nav />
      <main>
        <Hero />
        <GlobalTrustStrip />
        <ServicesFour />
        <ErpLeadership />
        <TrustLogos />
        <Products />
        <SuccessStories />
        <WorldMap />
        <WhyMaxine />
        <WebPackages />
        <Process />
        <Cloud />
        <Marketing />
        <CaseStudies />
        <Insights />
        <Careers />
        <GlobalReach />
        <Contact />
      </main>
      <Footer />
      <WhatsappFAB />
      <MobileStickyCTA />
      <TawkChat />
    </div>
  );
}
